export const environment = {
  production: true,
  API_URL: 'prod',
  authUrl: 'prod',
  authUrlLogout: 'prod',
  BASE_URL : 'https://smartclaim.thailife.com/SmartclaimService/rest'
};
